export const pagePaths = {
  home: "/",
  distributor: "/distributor",
  distributorPages: {
    teams: "teams",
    licensesPayments: "licenses-payments",
    clients: "clients",
    orders: "orders",
    analytics: "analytics",
    companyInfo: "company-info",
    checkout: "checkout",
    assignLicenses: "assign-licenses",
    myAccount: "my-account",
    licenses: "licenses",
  },
  classrooms: "/my-classrooms",
  classroomDetail: "/my-classrooms/:classroomId",
  classroomDetailPages: {
    members: "members",
    activities: "activities",
    corrections: "corrections",
    analytics: "analytics",
  },
  user: {
    report: ":userId/report",
    activities: ":userId/activities",
    analytics: ":userId/analytics",
    settings: ":userId/settings",
  },
  userActivities: {
    practiceExercises: "practice-exercises",
    practiceTests: "practice-tests",
    mockExams: "mock-exams",
    examSupport: "exam-support",
    assignments: "assignments",
  },
  levelPage: "/levels/:level",
  exercisePage: "/levels/:level/:section/:part/:number",
  practiceTestPage: "/practice-tests/:practiceTestId/user/:userId",
  mockExamPage: "/mock-exams/:level/:number/user/:userId",
  mockExamSectionPage: "/mock-exams/:level/:number/:section/user/:userId",
  classroomAddMembers: "/my-classrooms/:classroomId/addMembers",
  classroomBlockExercises: "/my-classrooms/:resourceId/blockExercises",
  studentBlockExercises: "/my-students/:resourceId/blockExercises",
  teachers: "/my-teachers",
  students: "/my-students",
  schoolPage: "/my-school-page",
  examSupport: "/exam-support",
  myAccount: "/my-account",
  myLicenses: "/my-licenses",
  applyLicenses: "/apply-licenses",
  checkout: "/checkout",
  myPayments: "/my-payments",
  correcctionsPending: "/corrections-pending",
  myProfile: "/my-profile",
  userData: "/users",
  authentication: "/authentication",
  signUp: "/authentication/sign-up",
  verifyEmailAddress: "/authentication/verify-email-address",
  signIn: "/authentication/sign-in",
  distributorSignIn: "/distributor/sign-in",
  resetPassword: "/authentication/reset-password",
  changePassword: "/authentication/change-password",
  updatePassword: "/authentication/update-password",
  support: "/support",
  userNotFound: "/user-not-found",
  userDisabled: "/user-disabled",
  privacyPolicy: "/privacy-policy",
  homeLogin: "/home",
};

export const pageSemiPaths = {
  level: "levels",
  mockExam: "mock-exams",
  user: "user",
};
